// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';
import logger from '../../../utils/clientLogger';
import {MultiUnitItem} from '../../MultiUnitItem/MultiUnitItem';
import {triggerMultipleUnitsResultCountEDAPEvent} from '../../../utils/hitEdapUtils';

import './MultiUnitListing.less';

type Props = {
    context: string,
    fullLocale: string,
    isDatelessSearch: boolean,
    isMetric: boolean,
    multiUnitList: Object,
    propertyId: number
};

const checkForNullFields = (list, field) => {
    return list.hasOwnProperty(field) && list[field] === null;
};

export default function MultiUnitListing(props: Props) {
    const {
        context,
        fullLocale,
        isDatelessSearch,
        isMetric,
        multiUnitList,
        propertyId
    } = props;
    const isListingsAvailable =
        multiUnitList &&
        multiUnitList.multiUnitSearch &&
        multiUnitList.multiUnitSearch.listings &&
        multiUnitList.multiUnitSearch.listings.length > 0;
    if (isListingsAvailable) {
        triggerMultipleUnitsResultCountEDAPEvent({
            propertyId,
            resultCount: multiUnitList.multiUnitSearch.listings.length
        });
        multiUnitList.multiUnitSearch.listings.map((list) => {
            Object.keys(list).forEach((property) => {
                if (checkForNullFields(list, property)) {
                    logger.captureMessage(
                        `[MultiUnitSearchQuery warning]: Received null value for field - ${property} and Listing Id -  ${
                            list.listingId
                        }`
                    );
                }
            });
            if (checkForNullFields(list, 'priceSummary')) {
                logger.captureException(
                    `[MultiUnitSearchQuery price error]: Received null value for price fields for Listing Id - ${
                        list.listingId
                    }`
                );
            }
        });
    }
    return (
        (isListingsAvailable &&
            multiUnitList.multiUnitSearch.listings.map((list) => (
                <MultiUnitItem
                    {...list} // watch out! `list` is type `any` so spreading it here means this component's props can't be type-checked!
                    context={context}
                    fullLocale={fullLocale}
                    isDatelessSearch={isDatelessSearch}
                    isMetric={isMetric}
                    key={list.listingId}
                    propertyId={propertyId}
                />
            ))) || (
            <div className="MultiUnit__ErrorMessage">
                <FormattedMessage id="tempOopsMessage" />
            </div>
        )
    );
}
